
export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-24 bg-[#f7f7f5]">
      <div className="max-w-5xl mx-auto px-5 md:px-12 text-center">
        <div className="mb-8 md:mb-10 flex justify-center">
          <div className="w-20 h-20 md:w-24 md:h-24 bg-gradient-to-br from-[#ff6b6b]/20 to-[#4ecdc4]/20 rounded-full flex items-center justify-center">
            <i className="ri-book-2-line text-4xl md:text-5xl text-[#1a2332]"></i>
          </div>
        </div>

        <p className="text-[#ff6b6b] text-[13px] md:text-base font-medium mb-5 md:mb-5 tracking-wider">
          About 후니국담
        </p>

        <h2 className="text-[1.35rem] sm:text-3xl md:text-4xl font-bold text-[#1a2332] mb-8 leading-[1.7] md:leading-[1.6] px-1" style={{ fontFamily: 'Noto Serif KR, serif' }}>
          <span className="block">후니국담은 단순히 국어를 가르치는 곳이 아닙니다.</span>
          <span className="block">학생 한 명 한 명의 언어적 사고력을 키우고,</span>
          <span className="block">깊이 있는 독해와 표현 능력을 함양하는 곳입니다. 📚</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6 mt-10 md:mt-14">
          <div className="bg-white rounded-2xl p-7 md:p-8 shadow-md hover:shadow-lg transition-shadow duration-300">
            <div className="w-14 h-14 md:w-14 md:h-14 bg-[#4ecdc4]/20 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-4">
              <i className="ri-user-star-line text-2xl md:text-2xl text-[#1a2332]"></i>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-[#1a2332] mb-3 md:mb-3">학교별 내신반 운영</h3>
            <p className="text-gray-600 text-[14px] md:text-base leading-relaxed">
              선택과 집중으로 최상의 결과
            </p>
          </div>

          <div className="bg-white rounded-2xl p-7 md:p-8 shadow-md hover:shadow-lg transition-shadow duration-300">
            <div className="w-14 h-14 md:w-14 md:h-14 bg-[#ff6b6b]/20 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-4">
              <i className="ri-trophy-line text-2xl md:text-2xl text-[#1a2332]"></i>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-[#1a2332] mb-3 md:mb-3">검증된 커리큘럼</h3>
            <p className="text-gray-600 text-[14px] md:text-base leading-relaxed">
              15년간 축적된 노하우로 체계적인 학습 프로그램 제공
            </p>
          </div>

          <div className="bg-white rounded-2xl p-7 md:p-8 shadow-md hover:shadow-lg transition-shadow duration-300">
            <div className="w-14 h-14 md:w-14 md:h-14 bg-[#1a2332]/20 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-4">
              <i className="ri-heart-line text-2xl md:text-2xl text-[#1a2332]"></i>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-[#1a2332] mb-3 md:mb-3">맞춤형 관리</h3>
            <p className="text-gray-600 text-[14px] md:text-base leading-relaxed">
              학생별 학습 진도와 성취도 관리
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
